import { slider_home } from "../actions/constants";

const initState = {
  loading: false,
  slider_home: [],
};

const SliderHomeReducer =  (state = initState, action) => {
  switch (action.type) {
    case slider_home.GET_SLIDER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case slider_home.GET_SLIDER_SUCCESS:
      return {
        ...state,
        slider_home: action.payload.slider_home,
        loading: false,
      };

    case slider_home.GET_SLIDER_FAILURE:
      return {
        ...initState,
      };

    default:
      return state;
  }
};

export default SliderHomeReducer;